module.exports = __webpack_public_path__ + "static/media/berzerk.763e0151.JPEG";